import { render } from "./FooterSocial.vue?vue&type=template&id=f74fc930&scoped=true&ts=true"
import script from "./FooterSocial.vue?vue&type=script&lang=ts"
export * from "./FooterSocial.vue?vue&type=script&lang=ts"

import "./FooterSocial.vue?vue&type=style&index=0&id=f74fc930&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f74fc930"]])

export default __exports__